import { UPLOAD_FILE_USER_REQUEST,UPLOAD_FILE_USER_SUCCESS,UPLOAD_FILE_USER_FAILURE,
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAILURE,
  GET_PUBLISHED_REQUEST,
  GET_PUBLISHED_SUCCESS,
  GET_PUBLISHED_FAILURE,
  GET_PROJECT_REQUEST_ADMIN2,
  GET_PROJECT_SUCCESS_ADMIN2,
  GET_PROJECT_FAILURE_ADMIN2} from '../Constants/ActionTypes.js';

export const FileReducer = (state = { newsData: [], isLoading: false }, action) => {
  switch (action.type) {
    case UPLOAD_FILE_USER_REQUEST:
      return { ...state, isLoading: true };
    case UPLOAD_FILE_USER_SUCCESS:
      return { ...state, newsData: action.payload, isLoading: false };
    case UPLOAD_FILE_USER_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export const projectInfoReducer = (state = { newsData: [], isLoading: false }, action) => {
  switch (action.type) {
    case GET_PROJECT_REQUEST:
      return { ...state, isLoading: true };
    case GET_PROJECT_SUCCESS:
      return { ...state, newsData:action.payload, isLoading: false };
    case GET_PROJECT_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export const getPublishedPapersReducer = (state = { paperData: [], isLoading: false }, action) => {
  switch (action.type) {
    case GET_PUBLISHED_REQUEST:
      return { ...state, isLoading: true };
    case GET_PUBLISHED_SUCCESS:
      return { ...state, paperData:action.payload, isLoading: false };
    case GET_PUBLISHED_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};



export const projectInfoAdmin2Reducer = (state = { projData: [], isLoading: false }, action) => {
  switch (action.type) {
    case GET_PROJECT_REQUEST_ADMIN2:
      return { ...state, isLoading: true };
    case GET_PROJECT_SUCCESS_ADMIN2:
      return { ...state, projData:action.payload, isLoading: false };
    case GET_PROJECT_FAILURE_ADMIN2:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};